import React, { useState, Fragment, useMemo, useContext } from 'react';
import { HeardSearch } from '../heardSearch';
import { IMemberInfo, SEARCH_TYPE } from '../../interface';
import { useRequest } from 'ahooks';
import { getKnowledgePointsDepartmentSearchList } from '../../service/knowledgePoint';
import { components } from 'common';
import SearchMemberList from '../searchMemberList';
import IfShow from '../ifShow';
import { lang } from '@umu/ukit-lang';
import './index.scss';
import { SearchPageContext } from '../../context';
import { getWorkspaceDepartmentSearchList } from '../../service/workspace';
interface IProps {
    isMultiple?: boolean;
    defaultSelectList: IMemberInfo[];
    onBack: () => void;
    onChange: (info: IMemberInfo[]) => void;
}
const { Loading } = components;

function SearchPanel(props: IProps) {
    const { isMultiple = false, defaultSelectList = [], onBack, onChange } = props;
    const { state } = useContext(SearchPageContext);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [selectList, setSelectList] = useState<IMemberInfo[]>([...defaultSelectList]);
    const { data, run } = useRequest(
        async (val: string, isInit?: boolean) => {
            if (isInit) {
                setSearchValue('');
                return Promise.resolve([]);
            }
            if (state.paramsInfo.searchType === SEARCH_TYPE.KNOWLEDGE_POINT_DEPARTMENT) {
                const info = await getKnowledgePointsDepartmentSearchList(val);
                loading && setLoading(false);
                return info;
            }
            if (state.paramsInfo.searchType === SEARCH_TYPE.WORKSPACE_DEPARTMENT) {
                const info = await getWorkspaceDepartmentSearchList(val);
                loading && setLoading(false);
                return info;
            }
            return Promise.resolve([]);
        },
        {
            debounceWait: 500,
            manual: true,
        },
    );

    const onSearch = (val: string) => {
        setSearchValue(val);
        if (!loading) {
            setIsFirstLoad(false);
            setLoading(true);
            run(val);
        }
    };
    const onItemClick = (item: IMemberInfo) => {
        const isCheck = selectList.some((selectItem) => selectItem.id === item.id);
        let newSelectMemberList: IMemberInfo[] = [];
        if (isCheck) {
            newSelectMemberList = selectList.filter((selectItem) => selectItem.id !== item.id);
        } else {
            newSelectMemberList = isMultiple ? [...selectList, item] : [item];
            onChange(newSelectMemberList);
            run('', true);
        }
        setSelectList(newSelectMemberList);
    };
    const isShowInitText = useMemo(() => {
        return isFirstLoad || (searchValue === '' && data?.length === 0);
    }, [isFirstLoad, searchValue, data]);
    return (
        <Fragment>
            <HeardSearch defaultValue={searchValue} onSearch={onSearch} onBack={onBack} />
            <IfShow condition={!loading && !isShowInitText}>
                <SearchMemberList
                    searchValue={searchValue}
                    selectList={selectList}
                    list={data || []}
                    loading={loading}
                    onItemClick={onItemClick}
                    isMultiple={state.paramsInfo.isMultiple}
                />
            </IfShow>
            <IfShow condition={isShowInitText}>
                <div className="member-search-init-text">{lang('请输入部门名称或账户信息开始搜索')}</div>
            </IfShow>
            <IfShow condition={loading}>
                <Loading />
            </IfShow>
        </Fragment>
    );
}

export default SearchPanel;
